import { useState, useEffect, useRef } from "react";
import "./street.css";

const API = process.env.REACT_APP_API_URL;


const a = [
  "Center",
  "Arabkir",
  "Davtashen",
  "Ajapnyak",
  "VahagniDistrict",
  "KanakerZeytun",
  "Avan",
  "NorNorq",
  "NorkMarash",
  "Shengavit",
  "MalatiaSebastia",
  "Erebuni",
  "Jrvej",
  "Zovuni",
  "Dzoraghpyur",
  "Ptghni",
  "Arzni",
  "Qasakh",
  "NorGeghi",
  "NorHajn",
  "Tsakhkadzor",
  "Abovyan",
  "Proshyan",
  "Arinj",
  "Byureghavan",
  "Yeghvard",
  "Dilijan",
];

const GROUP1 = a.slice(0, 12); // Center ... Erebuni   -> district
const GROUP2 = a.slice(12, 26); // Jrvej ... NorGeghi   -> district1
const GROUP3 = a.slice(26);

const districtLabels = {
    Center: "ԿԵՆՏՐՈՆ",
    Arabkir: "ԱՐԱԲԿԻՐ",
    Davtashen: "ԴԱՎԹԱՇԵՆ",
    Ajapnyak: "ԱՋԱՓՆՅԱԿ",
    VahagniDistrict: "ՎԱՀԱԳՆԻ",
    KanakerZeytun: "ՔԱՆԱՔԵՌ-ԶԵՅԹՈՒՆ",
    Avan: "ԱՎԱՆ",
    NorNorq: "ՆՈՐ ՆՈՐՔ",
    NorkMarash: "ՆՈՐՔ-ՄԱՐԱՇ",
    Shengavit: "ՇԵՆԳԱՎԻԹ",
    MalatiaSebastia: "ՄԱԼԱԹԻԱ-ՍԵԲԱՍՏԻԱ",
    Erebuni: "ԷՐԵԲՈՒՆԻ",
    Jrvej: "ՋՐՎԵԺ",
    Zovuni: "ԶՈՎՈՒՆԻ",
    Dzoraghpyur: "ՁՈՐԱՂԲՅՈՒՐ",
    Ptghni: "ՊՏՂՆԻ",
    Arzni: "ԱՐԶՆԻ",
    Qasakh: "ՔԱՍԱԽ",
    NorGeghi: "ՆՈՐ ԳԵՂԻ",
    NorHajn: "ՆՈՐ ՀԱՃՆ",
    Tsakhkadzor: "ԾԱՂԿԱՁՈՐ",
    Abovyan: "ԱԲՈՎՅԱՆ",
    Proshyan: "ՊՌՈՇՅԱՆ",
    Arinj: "ԱՌԻՆՋ",
    Byureghavan: "Բյուրեղավան",
    Yeghvard: "Եղվարդ",
    Dilijan: "Դիլիջան",
  };

export default function Street({district, district1,district2,selectedStreets,
  setSelectedStreets }) {
  const [query, setQuery] = useState("");
  const [filtered, setFiltered] = useState({});
  const [streetLanguage, setStreetLanguage] = useState({});
  const containerRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    fetch(`${API}/streets`)
      .then((res) => res.json())
      .then((data) => setStreetLanguage(data))
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
  const handleClickOutside = (e) => {
    if (containerRef.current && !containerRef.current.contains(e.target)) {
      setQuery("");
      // оставляем только выбранные
      setFiltered(selectedStreets.length > 0 ? { "__selected__": [...selectedStreets] } : {});
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, [selectedStreets]); // ← добавь selectedStreets в зависимости
	
  

  const handleChange = (e) => {
  const value = e.target.value;
  setQuery(value);

  if (!value) {
    // показываем только выбранные если они есть
    if (selectedStreets.length > 0) {
      setFiltered({ "__selected__": [...selectedStreets] });
    } else {
      setFiltered({});
    }
    return;
  }

  const resultObj = {};
  const streetsByLang = streetLanguage["armenian"];
  if (!Array.isArray(streetsByLang)) return;

  if (selectedStreets.length > 0) {
    resultObj["__selected__"] = [...selectedStreets];
  }

  for (let i = 0; i < streetsByLang.length; i++) {
    const streetsInDistrict = streetsByLang[i];
    if (!Array.isArray(streetsInDistrict)) continue;

    const matches = streetsInDistrict.filter(
      (street) =>
        street?.toLowerCase().includes(value.toLowerCase()) &&
        !selectedStreets.includes(street)
    );

    if (matches.length > 0) {
      resultObj[a[i]] = matches;
    }
  }

  setFiltered(resultObj);
};
   
  const toggleStreet = (street) => {
  setSelectedStreets((prev) => {
    const next = prev.includes(street)
      ? prev.filter((s) => s !== street)
      : [...prev, street];

    // обновляем filtered с новым списком выбранных
    setFiltered((prevFiltered) => {
      const updatedFiltered = { ...prevFiltered };
      if (next.length > 0) {
        updatedFiltered["__selected__"] = next;
      } else {
        delete updatedFiltered["__selected__"];
      }
      return updatedFiltered;
    });

    return next;
  });
};

  const allEmpty =
    district.length === 0 && district1.length === 0 && district2.length === 0;

  const isVisible = (index, group) => {
    if (allEmpty) return true;
    if (group === 1) return district.includes(index);
    if (group === 2) return district1.includes(index);
    return district2.includes(index);
  };

  const renderGroup = (groupKeys, groupNumber) =>
    groupKeys.map((key, index) =>
      isVisible(index, groupNumber)
        ? filtered[key]?.map((street) => (
            <div key={street}>
              <p
                      style={{
                        padding: "2px",
                        cursor: "pointer",
                        fontWeight: selectedStreets.includes(street)
                          ? "bold"
                          : "normal",
                        color: selectedStreets.includes(street)
                          ? "green"
                          : "black", // ← добавь
                      }}
                      onClick={() => toggleStreet(street)}
                    >
                      {street}
                      <span>{districtLabels[key]}</span>
                    </p>
            </div>
          ))
        : null,
    );
  console.log(selectedStreets)
  return (
    <div className="street" ref={containerRef}>
      <input
        type="text"
	autoComplete="off"
        style={{
          borderRadius: "10px",
          border: "2px solid black",
        }}
        name="street"
        value={query}
        onChange={handleChange}
        placeholder="ՓՈՂՈՑ"
      />
      
      {Object.keys(filtered).length > 0 && (
  <div className="filteredStreet">
    {/* выбранные улицы вверху */}
    {filtered["__selected__"]?.length > 0 && (
      <div className="selectedStreetsWrapper">
        {(isExpanded
          ? filtered["__selected__"]
          : filtered["__selected__"].slice(0, 1)
        ).map((street) => (
          <div key={street} className="selectedStreetItem">
            <p
              className="selectedStreetText"
              onClick={() => toggleStreet(street)}
            >
              {street}
            </p>
            <button
              type="button"
              className="selectedStreetRemoveBtn"
              onClick={() => toggleStreet(street)}
            >
              ✕
            </button>
          </div>
        ))}
        {filtered["__selected__"].length > 1 && (
          <div
            className="selectedStreetToggle"
            onClick={() => setIsExpanded((prev) => !prev)}
          >
            {isExpanded ? "▲" : "▼"}
          </div>
        )}
      </div>
    )}
	
      {/* остальные результаты */}
    {renderGroup(GROUP1, 1)}
    {renderGroup(GROUP2, 2)}
    {renderGroup(GROUP3, 3)}
  </div>
)}

      {selectedStreets.map((street, i) => (
        <input key={i} type="hidden" name="street" value={street} />
      ))}
    </div>
  );
}
